import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const SidebarCard = styled.aside`
  ${({ theme }) => css`
    padding: 32px 0 0;
    margin: 0;
    border-radius: 0;

    width: 100%;
    height: max-content;
    background: ${theme.colorsV2.white};
    position: relative;

    ${theme.mediaQueries.md} {
      border-radius: 20px;

      border: 1px solid ${theme.colorsV2.gray30};
      padding: 32px 24px;
    }
  `}
`;

export const SectionV2 = styled.div<{
  alignment?: 'center' | 'left';
  noMarginBottom?: boolean;
}>`
  ${({ alignment = 'left', noMarginBottom = false }) => css`
    display: flex;
    flex-direction: column;
    align-items: ${alignment === 'left' ? 'flex-start' : 'center'};
    gap: 16px;

    margin-top: 32px;
    width: 100%;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }

    ${noMarginBottom &&
    css`
      margin-bottom: 0;
    `}
  `}
`;

export const SectionTitle = styled(Text).attrs({ textStyle: 'overline' })`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray70};
  `}
`;

export const SectionContent = styled.div<{
  alignment?: 'center' | 'left';
  removeGap?: boolean;
}>`
  ${({ alignment = 'left', removeGap = false }) => css`
    display: flex;
    flex-direction: column;
    ${!removeGap &&
    css`
      gap: 16px;
    `}
    width: 100%;

    ${alignment === 'left' &&
    css`
      text-align: left;
      align-items: flex-start;
    `}

    ${alignment === 'center' &&
    css`
      text-align: center;
      margin: auto;
      align-items: center;
      justify-content: center;
    `}
  `}
`;
